import React, { useState, useEffect } from "react";
import Link from "@/utils/link";

import Button from "@/ui/Button";

import CpHero from "./CpHero";
import CpPricing from "./CpPricing";
import CpGetStartedCards from "./CpGetStartedCards";
import CpHomeHeader from "./CpHomeHeader";
import CpHomeFooter from "./CpHomeFooter";

const CpHome = ({ companyMarkdownCode }) => {
    return (
        <div>
            <CpHomeHeader />

            <div>
                <CpHero companyMarkdownCode={companyMarkdownCode} />

                {/*<div className="py-12 bg-gray-200">
                    <div className="flex justify-center">
                        <Link href="https://meetings.hubspot.com/community49">
                            <a className="px-4 py-2 uppercase font-headline bg-primary-500 rounded text-white">
                                Schedule Demo
                            </a>
                        </Link>
                    </div>
                    <p className="mt-4 flex justify-center">
                        Or call a Purple Door expert today at 612-PURPLE-3
                    </p>
                </div>*/}

                <div className="w-full bg-primary-500 py-6 text-white">
                    <h3 className="uppercase flex justify-center text-2xl font-bold">
                        Need More Help?
                    </h3>

                    <div className="mt-4 px-8 sm:px-16 flex justify-center text-xl font-bold flex-wrap">
                        Call us at 612-PURPLE-3 or
                        <a
                            href="mailto:community@purpledoorfinders.com"
                            className="ml-2 underline hover:text-primary-200"
                        >
                            community@purpledoorfinders.com
                        </a>
                    </div>

                    <div className="mt-2 flex justify-center">
                        <Button
                            variant="contained"
                            color="white"
                            href="/community-portal/community-support"
                            className="mt-4 w-32"
                        >
                            Contact
                        </Button>
                    </div>
                </div>

                <CpPricing />

                <CpGetStartedCards />
            </div>

            <CpHomeFooter />
        </div>
    );
};

export default CpHome;
